module.exports = __webpack_public_path__ + "static/media/PEAK.0d44a0f5.svg";